import { render } from "./AppTutorialsBody.vue?vue&type=template&id=14dc45dc"
import script from "./AppTutorialsBody.vue?vue&type=script&lang=js"
export * from "./AppTutorialsBody.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__